module.exports = __webpack_public_path__ + "static/media/Computer Org & Arch.35b71e1f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CSE/Computer Org & Arch.pdf
// module id = 98
// module chunks = 0